import React, { Component }  from 'react'
import StyleSheet            from 'styles'
import Allocation            from './Allocation'
import BookBuild             from './BookBuild'
import { Authorization }     from 'utils'
import { withRouter }              from 'react-router'

export class Show extends Component{

  renderBody = () => {
    if (Authorization.investor || this.props.match.params.allocationId)
      return <Allocation allocationId={this.props.match.params.allocationId}/>
    else if (Authorization.admin || Authorization.issuer)
      return <BookBuild dealSheet={this.props.dealSheet}/>
    else
      return "You are not allowed to view this tab"
  }

  get dealSheetId() {
    return this.props.match.params.id
  }

  render = () =>
    <div className={styles.showContainer}>
      {this.renderBody()}
    </div>
}


const styles = StyleSheet({
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'flex-start',
    flexDirection: 'row',
    flexWrap: 'wrap',
    flex: 1,
  },
  showContainer: {
    flex: 1,
    padding: '10px 0',
    display: 'flex',
    flexDirection: 'row'
  },
})


export default withRouter(Show)